export default { sha: '2e39dce133d1a5ae72945ffd657daf70f0493f0b', buildNumber: 'undefined' }
